import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(ScrollTrigger, CustomEase);
gsap.config({ nullTargetWarn: false });

// 画像の読み込み完了を待つ
window.addEventListener('load', () => {
  // 全ての初期設定をまとめて行う
  gsap.set(['.mark1', '.mark2', '.mark3'], {
    scale: 1,
    top: '17.6rem',  // 初期位置
    opacity: 0
  });
  gsap.set('.mark0', { opacity: 0 });
  gsap.set('.mark4', { opacity: 0 });
  //gsap.set('.mark1', { y: '14.6rem' });
  //gsap.set('.mark2', { y: '14.6rem' });//-2923.47656px
  //gsap.set('.mark3', { y: '14.6rem' });//-2923.47656px
  gsap.set('.grandopen', { opacity: 0, y: 20 });
  gsap.set('.bg', { opacity: 0 });
  //gsap.set(['.obj1', '.obj2'], { opacity: 0 });
  gsap.set('.building .mask', { scaleX: 1, transformOrigin: 'center center' });
  gsap.set('.base', { opacity: 0, scale: 0.95 });

  // バーの初期設定
  gsap.set(['.bar1', '.bar2', '.bar3', '.bar4', '.bar5', '.bar6', '.bar7'], {
    top: 'calc(100% + 60rem)',
    scaleY: 0  // 初期状態でもscaleY: 0を設定
  });

  // バーのアニメーション関数
  const animateBar = (barClass, delay = 0.02) => {
    return gsap.timeline()
      .to(barClass, {
        scaleY: 3,
        duration: 0,
        delay: delay
      })
      .to(barClass, {
        top: '-10.8rem',
        duration: 1.7,
        scaleY: 1,
        ease: "power2.inOut",
        delay: 1,
        onUpdate: function () {
          // このアニメーションの進行度を取得
          const progress = this.progress();

          // 進行度が0.5（中央付近）の時に.progressをフェードアウト
          if (progress >= 0.7 && barClass === '.bar1') {  // .bar1の時のみ実行
            gsap.to('.progress', {
              opacity: 0,
              duration: 0
            });
          }
        }
      });
  };

  // メインのバーアニメーションタイムライン
  const barsTl = gsap.timeline();

  // 各バーのアニメーションを順番に追加
  const stagger = 0.02; // バー間の遅延時間
  ['.bar1', '.bar2', '.bar3', '.bar4', '.bar5', '.bar6', '.bar7'].forEach((bar, index) => {
    barsTl.add(animateBar(bar, index * stagger), index * stagger);
  });

  // 最後のバーのアニメーション完了後にローディング画面をフェードアウト

  barsTl.then(() => {
    gsap.to('.loading-overlay', {
      opacity: 0,
      duration: 0.5,
      delay: 0.5,
      onComplete: () => {
        gsap.set('.loading-overlay', { display: 'none' });

        // メインのアニメーションタイムライン
        const tl = gsap.timeline();
        tl
          .to('.mark1', {
            opacity: 1,
            top: '20.6rem',
            duration: 0.3,
            ease: 'back.out(1.7)'
          })
          .to('.mark2', {
            opacity: 1,
            top: '20.6rem',
            duration: 0.3,
            ease: 'back.out(1.7)',
            delay: 0.6
          })
          .to('.mark3', {
            opacity: 1,
            top: '20.6rem',
            duration: 0.3,
            ease: 'back.out(1.7)'
          }, "-=0.6")
          .to('.mark4', {
            opacity: 1,
            top: '20.6rem',
            duration: 0,
            onComplete: () => {
              gsap.set(['.mark1', '.mark2', '.mark3'], { display: 'none' });
            }
          })
          .to(['.mark4'], {
            scale: 0.067,
            //stagger: 0.015,
            top: '3.6rem',
            duration: 0.65,
            //ease: 'back.inOut(1.8)',
            ease: CustomEase.create("custom", "M0,0 C0,0 0.158,-0.21 0.205,-0.212 0.222,-0.213 0.242,-0.209 0.255,-0.204 0.268,-0.199 0.294,-0.182 0.307,-0.169 0.322,-0.155 0.349,-0.117 0.362,-0.094 0.377,-0.067 0.401,-0.015 0.417,0.03 0.458,0.149 0.526,0.632 0.565,0.754 0.579,0.799 0.597,0.848 0.61,0.876 0.621,0.902 0.646,0.949 0.66,0.968 0.673,0.987 0.702,1.017 0.717,1.027 0.732,1.037 0.759,1.048 0.78,1.049 0.83,1.052 1,1 1,1 "),
            delay: 0.6,
            // onComplete: () => {
            //   gsap.set(['.mark1', '.mark2', '.mark3'], { display: 'none' });
            // }
          })
          .to('.mark0', {
            scale: 1,
            opacity: '1',
            duration: 0
          })
          .to('.base', {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: 'back.out(10)',
            delay: 0.3
          })
          .to('.catch', {  // .catchのアニメーションを追加
            opacity: 1,
            y: 0,  // 必要に応じて
            duration: 0.4,
            ease: 'power2.out'
          })
          .to('.building .mask', {
            scaleX: 0,
            duration: 0.5,
            delay: 0.1,
            ease: 'power3.inOut',
            onComplete: () => {
              gsap.set('.building .mask', { display: 'none' })
            }
          })
          .to('.bg', {
            opacity: 1,
            duration: 1.2,
            ease: 'power2.out'
          })
          // .to(['.obj1', '.obj2'], {
          //   opacity: 0.7,
          //   duration: 1.2,
          //   ease: 'power2.out'
          // }, "-=1.2")
          .to('.grandopen', {
            opacity: 1,
            y: 0,
            duration: 0.4,
            ease: 'back.out(4)',
          }, "-=0.6");
      }
    });
  });
});

